<template>
  <span class="currency" v-html="formatted"></span>
</template>

<script>
  export default {
    props: {
      value: {
        type: Number,
      },
    },
    computed: {
      formatted () {
        return `${this.value}&nbsp;Р.`
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/currency.vue